import { render, staticRenderFns } from "./RecoveryAtIdB.html?vue&type=template&id=c115a460&scoped=true&"
import script from "./RecoveryAtIdB.vue?vue&type=script&lang=js&"
export * from "./RecoveryAtIdB.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryAtIdB.scss?vue&type=style&index=0&id=c115a460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c115a460",
  null
  
)

export default component.exports